import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  QuoteClauseRequest,
  QuoteClauseResponse,
  QuoteClausesSetRequest
} from '../models/quote-clause.model';

/**
 * API del catálogo de cláusulas de cotización (/api/quote-clauses) y de las
 * cláusulas seleccionadas en una cotización (PUT /api/quotes/{id}/clauses).
 */
@Injectable({
  providedIn: 'root'
})
export class QuoteClauseApiService {
  private readonly apiUrl = `${environment.apiUrl}api/quote-clauses`;
  private readonly quotesUrl = `${environment.apiUrl}api/quotes`;

  constructor(private http: HttpClient) { }

  // GET /api/quote-clauses — cláusulas activas ordenadas por sortOrder. Rol Sales Rep+.
  getClauses(businessId: number): Observable<QuoteClauseResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteClauseResponse[]>(this.apiUrl, { params })
      .pipe(map(r => r ?? []));
  }

  // POST /api/quote-clauses — Rol Manager+.
  createClause(businessId: number, request: QuoteClauseRequest): Observable<QuoteClauseResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<QuoteClauseResponse>(this.apiUrl, request, { params });
  }

  // PUT /api/quote-clauses/{id} — Rol Manager+.
  updateClause(id: number, businessId: number, request: QuoteClauseRequest): Observable<QuoteClauseResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteClauseResponse>(`${this.apiUrl}/${id}`, request, { params });
  }

  // DELETE /api/quote-clauses/{id} — Rol Manager+.
  deleteClause(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }

  // PUT /api/quotes/{id}/clauses — reemplaza el conjunto de cláusulas de una cotización.
  // El orden de clauseIds define el sortOrder; lista vacía elimina todas.
  setQuoteClauses(quoteId: number, businessId: number, request: QuoteClausesSetRequest): Observable<QuoteClauseResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteClauseResponse[]>(`${this.quotesUrl}/${quoteId}/clauses`, request, { params })
      .pipe(map(r => r ?? []));
  }
}
